import React from 'react'
import { useDispatch } from 'react-redux'

import { GlgButton } from 'Shared/components'
import BaseCloningModal from './BaseCloningModal'
import { setCloningModal } from '../../../reducers/cloning_steps'
import useCloningStepsActions from '../../../hooks/useCloningStepsActions'

const modalContent = (
  <>
    <span>{window.I18n.t('clone_leagues_sessions.modals.missing_renames.content_1')}</span>
    <span>{window.I18n.t('clone_leagues_sessions.modals.missing_renames.content_2')}</span>
  </>
)

const MissingRenamesModal = () => {
  const dispatch = useDispatch()
  const { confirmNextCloningStep } = useCloningStepsActions()

  return (<BaseCloningModal
    title={window.I18n.t('clone_leagues_sessions.modals.missing_renames.title')}
    content={modalContent}
    leftButton={<GlgButton
      className={'cls-steps-modal__left_button'}
      text={window.I18n.t('clone_leagues_sessions.modals.missing_renames.back')}
      onClick={() => dispatch(setCloningModal(null))}
    />}
    rightButton={<GlgButton
      className={'cls-steps-modal__right_button'}
      text={window.I18n.t('clone_leagues_sessions.modals.missing_renames.confirm')}
      onClick={confirmNextCloningStep}
    />}
  />)
}

export default MissingRenamesModal
